/* eslint-disable import/order -- Public path and polyfills need to be setup first */
import 'cadenza/public-path';
import 'cadenza/polyfills';
/* eslint-enable import/order */

import '../css/base.css';

import $ from 'jquery';
import 'jquery-migrate/dist/jquery-migrate.min'; // jquery-migrate in production mode; import before any jQuery code

import 'ui/alert/alert';
import 'ui/alerts/alerts';
import 'ui/progress-spinner/progress-spinner';
import 'ui/sidebar/sidebar';
import 'ui/progress-spinner-overlay/progress-spinner-overlay';

import { setupEllipsis } from 'cadenza/utils/ellipsis';
import { showHelpDialogIfNotLocallyDisabled } from 'cadenza/navigation/help-dialog/help-dialog';
import 'cadenza/header/subnav';
import 'cadenza/header/topnav';
import { logger } from 'cadenza/utils/logging';
import { commonI18n as i18n } from 'cadenza/utils/i18n/i18n';
import { applyThemeProperties } from 'cadenza/theming-api';
import { errorAlert } from 'cadenza/alert';
import { setupKeynav } from 'cadenza/utils/setup-keynav';
import { cadenzaUrl } from 'cadenza/utils/cadenza-url/cadenza-url';
import { postMessage } from 'cadenza/integration/post-message';
import { on } from 'cadenza/utils/event-util';
import { clearPerformanceMetadata, setPerformanceMetadata } from 'cadenza/api-client/performance-analysis-api';
import { setupSessionPoller } from 'cadenza/session-polling/session-poller';
import { cadenzaTopWindow } from 'cadenza/utils/iframe';
import { initializeSessionStorageForCadenza } from 'cadenza/utils/session-storage/session-storage-util';

const Disy = window.Disy;

initializeSessionStorageForCadenza();

applyThemeProperties(Disy.theme);

setupSessionPoller(window.Disy.cadenzaSessionPollingInterval);

Object.assign(window.disyCommons, {
  i18n,
  logger,
  initializeNavigation: () => {
    // If the start page is loaded, we need to initialize navigation.
    if (window.Disy.isStartPage) {
      importAndInitializeNavigation();
      return;
    }

    // Otherwise we initialize navigation on the first click of the navigationTrigger button.
    // After the initialization we need to programmatically click on the button one more time
    // because only then will the click event responsible for showing navigation be triggered.
    const navigationTrigger = document.getElementById('navigationTrigger');
    on(
      navigationTrigger,
      'click',
      () => {
        importAndInitializeNavigation()
          .then(() => navigationTrigger.click())
          .catch(logger.error);
      },
      { once: true });
  },
  cadenzaUrl,
  showHelpDialogIfNotLocallyDisabled,
  postMessage
});

// We return a promise which is finished once the navigation is initialized.
async function importAndInitializeNavigation (toggleState) {
  const { initializeNavigation } = await import(/* webpackChunkName: "navigation" */ 'cadenza/navigation/navigation');
  await initializeNavigation(!!toggleState);
}

function registerClickHandlerForSkipToNavigator () {
  // Load the navigation lazily on click.
  const skipButton = document.querySelector('#skip-to-navigator');
  if (skipButton) {
    on(skipButton, 'click', () => {
      importAndInitializeNavigation(true);
    });
  }
}

if (Disy.debug) {
  logger.enableAll(false); // do not persist the log level in localStorage
}

Object.assign(Disy, {
  errorAlert,
  cadenzaTopWindow,

  // Used in internal load tests
  setPerformanceMetadata,
  clearPerformanceMetadata
});

setupKeynav();
setupEllipsis();

// Make jQuery globally available for inline scripts (yes, they're bad)
window.$ = $;
window.jQuery = $;

$(() => {
  document.body.classList.toggle('is-touch', 'ontouchstart' in window);
  registerClickHandlerForSkipToNavigator();
});

if (window.Disy.debug) {
  document.addEventListener('focusout', (event) => {
    // "focusout" is dispatched before the element is removed.
    // So we need to defer the contains() check.
    requestAnimationFrame(() => {
      if (document.activeElement === document.body && !document.body.contains(event.target)) {
        logger.log('Please fix the focus management of your component: '
          + 'The focus was dropped, because the active element (see below) was removed from the DOM. '
          + 'As a result, the document.body is focused now, which breaks the UX for keyboard users',
        event.target);
      }
    });
  });
}
